import React from "react"
import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell";

// const debug = "FieldMessagesTotal_TableCell"
const debug = false

export default function FieldMessagesTotal_TableCell(props:FieldTableCellProps) {

    const hasValue = !!props.listItem.task.messagesTotal && props.listItem.task.messagesTotal > 0

    return (

        <div className="cell-flex ui5-txt-less-important-small flex-row-center-center" style={getTableCellStyle(props)}>

            {hasValue &&
                <>
                    <div className="ui5-ico-13 i5-chat m-r-5 m-l-1"/>
                    {props.listItem.task.messagesTotal}
                </>
            }
        </div>

    )

}



